import React from 'react';
import { render } from 'react-dom'
import Logo from './logo'
import styled from 'styled-components';
import { Headerunit, Headertext, Headertextbig, Headertextsmall } from './header-style'

const Header = props => {
  const { winheight, winwidth, extrasmall } = props

  return (


    <Headerunit winwidth = {winwidth}>

        <Logo winwidth={winwidth} extrasmall={extrasmall} width={extrasmall ? winwidth/4 : winwidth/18 } />


        <Headertext winheight={winheight} winwidth={winwidth} fontsize={extrasmall ? winwidth/22 : winwidth/60 }>

              <Headertextbig winheight={winheight} >
                    ОБЛАСТНОЙ ЦЕНТР НОВЫХ ИНФОРМАЦИОННЫХ ТЕХНОЛОГИЙ
              </Headertextbig>

         </Headertext>
        <div>&nbsp;</div>
    </Headerunit>

);
};

export default Header;
